import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "user-stats",
  class: "user-stats"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = { class: "calendar" }
const _hoisted_4 = { class: "date-range" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = { key: 7 }
const _hoisted_9 = { key: 9 }
const _hoisted_10 = { key: 11 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_DropdownCalendar = _resolveComponent("DropdownCalendar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_DropdownCalendar, {
              modelValue: $data.range,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.range) = $event)),
              "filter-indicator": false,
              title: "Date Range",
              "min-date": _ctx.min_date
            }, null, 8 /* PROPS */, ["modelValue", "min-date"]),
            _createElementVNode("div", _hoisted_4, _toDisplayString($options.date), 1 /* TEXT */)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("label", null, "Logins", -1 /* HOISTED */)),
          ($data.stats?.login)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", null, "Total: " + _toDisplayString($data.stats.login), 1 /* TEXT */),
                _createElementVNode("div", null, "Last: " + _toDisplayString(_ctx.$utils.format.datetime($data.stats.last_login)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, " Never logged in ")),
          _cache[3] || (_cache[3] = _createElementVNode("label", null, "Pulse feed items clicked", -1 /* HOISTED */)),
          ($data.stats?.signal_click)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", null, "Total: " + _toDisplayString($data.stats.signal_click), 1 /* TEXT */),
                _createElementVNode("div", null, "Last: " + _toDisplayString(_ctx.$utils.format.datetime($data.stats.last_signal_click)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, " Never clicked ")),
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Pulse to chat", -1 /* HOISTED */)),
          ($data.stats?.signal_to_chat)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createElementVNode("div", null, "Total: " + _toDisplayString($data.stats.signal_to_chat), 1 /* TEXT */),
                _createElementVNode("div", null, "Last: " + _toDisplayString(_ctx.$utils.format.datetime($data.stats.last_signal_to_chat)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, " Never used ")),
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Emails delivered", -1 /* HOISTED */)),
          ($data.stats?.email_delivered)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                _createElementVNode("div", null, "Total: " + _toDisplayString($data.stats.email_delivered), 1 /* TEXT */),
                _createElementVNode("div", null, "Last: " + _toDisplayString(_ctx.$utils.format.datetime($data.stats.last_email_delivered)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, " No emails delivered ")),
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Emails opened", -1 /* HOISTED */)),
          ($data.stats?.email_opened)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                _createElementVNode("div", null, "Total: " + _toDisplayString($data.stats.email_opened), 1 /* TEXT */),
                _createElementVNode("div", null, "Last: " + _toDisplayString(_ctx.$utils.format.datetime($data.stats.last_email_opened)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, " Never opened ")),
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Email links clicked", -1 /* HOISTED */)),
          ($data.stats?.email_clicked)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                _createElementVNode("div", null, "Total: " + _toDisplayString($data.stats.email_clicked), 1 /* TEXT */),
                _createElementVNode("div", null, "Last: " + _toDisplayString(_ctx.$utils.format.datetime($data.stats.last_email_clicked)), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, " Never clicked "))
        ]))
  ]))
}